import React, { Component } from "react";
import { matchPath } from "react-router";

import api from "services/api";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Benefits/Campaign/components";

import swal from "sweetalert";

class Create extends Component {
  state = {
    data: {
      title: "",
      description: "",
      status_value: true,
    },
    loading: true,
    saving: false,
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Campanhas Comerciais", to: "/benefits/campaign/list" },
      { name: "Adicionar Nova", to: "" },
    ],
  };

  componentDidMount() {
    this.loadData();
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/benefits/campaign/:id/edit",
    });
    return match.params.id;
  };

  loadData = async () => {
    try {
      this.setState({ loading: true });
      const { data } = this.state;

      const id = this.handleGetID();

      const response = await api.get(
        `experience/v2/commercial_campaigns/${id}`
      );
      const { data: campaign } = response.data;

      this.setState({
        data: {
          ...data,
          title: campaign.attributes.title,
          description: campaign.attributes.description,
          status_value: campaign.attributes.status_value
        },
      });
    } catch (err) {
      swal(
        "Não encontrado",
        "Não foi possível encontrar a campanha comercial.",
        "error"
      );
      await this.props.history.push('/benefits/campaign/list')
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },
      description: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = async () => {
    if (!this.handleValidate()) return null;

    try {
      this.setState({ saving: true });
      const { data } = this.state;

      const id = this.handleGetID();

      await api.put(`experience/v2/commercial_campaigns/${id}`, {
        title: data.title,
        description: data.description,
        status_value: data.status_value,
      });

      swal("Sucesso", "Campanha comercial atualizada com sucesso.", "success");
      await this.props.history.push("/benefits/campaign/list");
    } catch (err) {
      swal(
        "Falha ao criar",
        "Não foi possível atualizar a campanha comercial.",
        "error"
      );
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const { data, loading, saving, errors, breadcrumbs } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        {!loading && (
          <Form
            data={data}
            errors={errors}
            saving={saving}
            onChange={this.handleChange}
            onSave={this.handleSave}
          />
        )}
      </Page>
    );
  }
}

export default Create;
